<span class="title">
  <span class="bold">{{ title | translate }}</span> {{ subtitle | translate }}
</span>
